import { createStyles, makeStyles } from '@material-ui/core/styles';
import { LIGHT_GRAY, BLACK, BORDER_GRAY, WHITE, YELLOW } from 'constants/colors';
export default makeStyles(theme => {
  const carSize = theme.spacing(14);
  return createStyles({
    vehicleDetailRoot: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      border: `${BORDER_GRAY} 1px solid`,
      borderRadius: 0,
      backgroundColor: LIGHT_GRAY
    },
    icon: {
      fontSize: carSize,
      [theme.breakpoints.down('sm')]: {
        fontSize: carSize * 0.6
      }
    },
    cardActions: {
      cursor: 'pointer',
      paddingLeft: theme.spacing(2)
    },
    cardContent: {
      background: YELLOW
    },
    tagNumberArea: {
      background: WHITE,
      color: BLACK
    },
    expand: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },
    expandOpen: {
      transform: 'rotate(180deg)'
    },
    header: {
      display: 'flex',
      marginTop: theme.spacing(2),
      justifyContent: 'space-between'
    },
    headerButton: {
      marginRight: theme.spacing(2)
    },
    underline: {
      textDecoration: 'underline'
    },
    vehicleDetailCardBorder: {
      border: `1px solid ${BORDER_GRAY}`
    },
    titleAndAgreementName: {
      display: 'flex',
      flexDirection: 'column'
    },
    noRegBox: {
      marginBottom: theme.spacing(2)
    },
    smallerMarginTop: {
      marginTop: theme.spacing(0.5)
    }
  });
});